import { Component } from 'react'
import { Alert, AlertTitle, Button } from '@mui/material'

// FAR-85: keeps a crash inside one panel (an Admin tab) from replacing the
// whole page with React Router's default error screen. Shows what failed and
// a retry; the rest of the page, the other tabs included, keeps working.
// resetKey: change it (e.g. the tab) to clear the error.
export default class PanelErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    console.error(`[${this.props.name || 'Panel'}] render failed:`, error, info?.componentStack)
  }

  componentDidUpdate(prev) {
    if (this.state.error && prev.resetKey !== this.props.resetKey) this.setState({ error: null })
  }

  render() {
    if (!this.state.error) return this.props.children
    return (
      <Alert severity="error" data-testid="panel-error"
        action={<Button color="inherit" size="small" onClick={() => this.setState({ error: null })}>Try again</Button>}>
        <AlertTitle>{this.props.name ? `${this.props.name} couldn't be shown` : "This section couldn't be shown"}</AlertTitle>
        {String(this.state.error?.message || this.state.error)}
      </Alert>
    )
  }
}
